import React from 'react';

import { ChipList } from '@/components/shared/Chip';
import { SongThemeChip } from '@/components/shared/SongThemeChip';
import { LimitedTeamSong } from '@/providers/TeamSongsProvider';

import styles from '../Songlist360Report.module.scss';

type CreateChipsProps = {
	tags: {
		label: string;
		capitalisedLabel: string;
	}[];
	songMetricsData: {
		id: string;
		songs: LimitedTeamSong[];
	}[];
};

export const CreateChips: React.FC<CreateChipsProps> = ({
	tags,
	songMetricsData,
}) => {
	const hasUnknown = songMetricsData.find((metric) => metric.id === 'unknown')
		?.songs.length;

	return (
		<ChipList className={styles['song-theme-list']}>
			{(hasUnknown ? [...tags, { label: 'unknown ' }] : tags).map(
				(t, i) => (
					<SongThemeChip key={`chip-${i}`} themeTag={t.label} />
				),
			)}
		</ChipList>
	);
};
